import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

/**
 * 设置session
 */
const setSession = (label, val = '') => {
  if(typeof(val) !== 'string'){
    val = JSON.stringify(val)
  }
  window.sessionStorage.setItem(label, val)
}



export default new Vuex.Store({
  state: {
    loader: true, // 加载状态
    view: 'pc', // 视图类型
    tabs: {
      list: [], // 标签列表
      now: '0', // 激活标签ID
      refresh: '' // 刷新标签ID
    },
    listHeight: 0, // 列表高度
    tableHeight: 0, // 表格高度
  },
  mutations: {
    // 更显列表高度
    updateListHeight (state, val) {
      state.listHeight = val
    },
    // 更显表格高度
    updateTableHeight (state, val) {
      state.tableHeight = val
    },
    // 更显视图
    updateView (state, val) {
      state.view = val ? 'pc' : 'wap'
    },
    // 更新状态
    updateLoader (state, val) {
      state.loader = val ? true : false
    },
    // 修改当前操作标签
    editTabNow (state, val) {
      state.tabs.now = val;
    },
    // 添加标签页
    addTab (state, obj) {
      state.tabs.refresh = ''
      if (obj && obj.id != '0') {
        let has = false // 标签存在
        for(let i =0; i<state.tabs.list.length; i++){
          if(state.tabs.list[i].id === obj.id){
            has = true
            state.tabs.list[i] = obj
            break;
          }
        }
        if (! has) {
          if (obj.pid) {
            // 存在父级别，在父后加入
            for(let i =0; i<state.tabs.list.length; i++){
              if (state.tabs.list[i].url == obj.pid) {
                state.tabs.list.splice(i+1, 0, obj)
                break;
              }
            }
          } else {
            // 添加到最后
            state.tabs.list.push(obj)
          }
        }
        state.tabs.now = obj.id
      } else {
        state.tabs.now = '0'
      }
      setSession('tabs', state.tabs)
    },
    // 删除标签页
    delTab (state, obj) {
      state.tabs.refresh = ''
      var list = []
      var index = 0
      state.tabs.list.forEach((e, i) => {
        if (obj.id != e.id) {
          list.push(e)
        } else {
          if (i > 0) {
            index = i - 1
          }
        }
      })
      state.tabs.list = list
      if (state.tabs.list.length > 0) {
        state.tabs.now = state.tabs.list[index].id
      } else {
        state.tabs.now = '0'
      }
      setSession('tabs', state.tabs)
    },
    // 清空标签
    clearTab (state) {
      state.tabs.refresh = ''
      state.tabs.list.length = 0
      state.tabs.now = '0'
    },
    // 标签返回
    backTab (state, refresh = {}) {
      state.tabs.refresh = ''
      var id = state.tabs.now
      var list = []
      var index = 0
      state.tabs.list.forEach((e, i) => {
        if (id != e.id) {
          list.push(e)
        } else {
          if(refresh && e.pid){
            state.tabs.refresh = e.pid
          }
          if (i > 0) {
            index = i - 1
          }
        }
      })
      state.tabs.list = list
      if (state.tabs.list.length > 0) {
        state.tabs.now = state.tabs.list[index].id
      } else {
        state.tabs.now = '0'
      }

      if(refresh.id){
        // 新标签页
        refresh.pid = state.tabs.refresh
        state.tabs.list.push(refresh)
        state.tabs.now = refresh.id;
      }
      setSession('tabs', state.tabs)
    },
    // 关闭其他标签
    delTabOther (state, index) {
      if(!index && index !== 0){
        // home 标签触发
        state.tabs.refresh = ''
        state.tabs.list = []
        state.tabs.now = '0'
      }else{
        //菜单 标签触发
        state.tabs.refresh = ''
        let list = [state.tabs.list[index]]
        state.tabs.list = list
        state.tabs.now = list[0].id
      }
      setSession('tabs', state.tabs)
    },
    // 关闭右侧标签
    delTabRight (state, index) {
      state.tabs.refresh = ''
      let now = ''
      state.tabs.list.splice(index+1)
      for(let i =0; i<state.tabs.list.length; i++){
        if(state.tabs.list[i].id === state.tabs.now){
          now = state.tabs.list[i].id
          break;
        }
      }
      if (now == '') {
        state.tabs.now = state.tabs.list.at(-1).id
      }
      setSession('tabs', state.tabs)
    },
    // 关闭全部标签
    delTabAll (state) {
      state.tabs.refresh = ''
      state.tabs.list = []
      state.tabs.now = '0'
      setSession('tabs', state.tabs)
    }
  },
  actions: {
  },
  modules: {
  }
})
